import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { routing, appRoutingProviders } from './rankings.routing.';
import { RankingsComponent } from './rankings.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../../pipes/pipes.module';
import { RankingsMainFilterItemsComponent } from './rankings-main-filter-items/rankings-main-filter-items.component';

import { ScrollbarHintDirective } from '../../../directives/scrollbar-hint.directive';
import { FixedTableHeaderDirective } from '../../../directives/fixed-table-header.directive';
import { SharedModule } from '../../shared/shared.module';
import { CoppaAudienceComponent } from './data-widgets/coppa-audience.component';
import { WidgetContainerComponent } from './data-widgets/widget-container.component';
import { RankingsHeadersSortPipe } from './pipes/rankings-headers-sort.pipe';
import { RankingsSidenavLinksComponent } from './rankings-sidenav-links/rankings-sidenav-links.component';
import { DirectivesModule } from '../../../directives/directives.module';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { GridHeaderContainerComponent } from './data-widgets/grid-header-container.component';
import { GridHeaderWithTooltipComponent } from './data-widgets/grid-header-with-tooltip.component';
import { GridHeaderWithPopoverComponent } from './data-widgets/grid-header-with-popover.component';
import { SellerNameComponent } from './data-widgets/seller-name.component';
import { AppNameComponent } from './data-widgets/app-name.component';
import { AppNameOnlyComponent } from './data-widgets/app-name-only.component';
import { PublisherNameComponent } from './data-widgets/publisher-name.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { RankGradeComponent } from './data-widgets/rank-grade.component';
import { DataOnlyComponent } from './data-widgets/data-only.component';
import { PercentDataComponent } from './data-widgets/percent-data.component';
import { DollarCurrencyDataComponent } from './data-widgets/dollar-currency-data.component';
import { BigNumberDataComponent } from './data-widgets/big-number-data.component';
import { YesnoComponent } from './data-widgets/yesno.component';
import { ShowIfPipe } from './pipes/show-if.pipe';
import { RatingBarComponent } from './data-widgets/rating-bar.component';
import { RankingsLabelParser } from './pipes/rankings-label-parser';
import { DomainNameComponent } from './data-widgets/domain-name.component';
import { RankingsSellerTableComponent } from './rankings-seller-modal-table/rankings-seller-modal-table.component';
import { SellerCountryComponent } from './data-widgets/seller-country.component';
import { SellerRegionComponent } from './data-widgets/seller-region.component';
import { GridHeaderWithPopoverSearchComponent } from './data-widgets/grid-header-with-popover-search.component';
import { RatingPillComponent } from './data-widgets/rating-pill.component';
import { RatingSignalComponent } from './data-widgets/rating-signal.component';
import { AppIdOnlyComponent } from './data-widgets/app-id-only.component';
import { OsNameComponent } from './data-widgets/os-name.component';

@NgModule({
  declarations: [
    AppIdOnlyComponent,
    AppNameComponent,
    AppNameOnlyComponent,
    BigNumberDataComponent,
    CoppaAudienceComponent,
    DataOnlyComponent,
    DollarCurrencyDataComponent,
    DomainNameComponent,
    FixedTableHeaderDirective,
    GridHeaderComponent,
    GridHeaderContainerComponent,
    GridHeaderWithPopoverComponent,
    GridHeaderWithPopoverSearchComponent,
    GridHeaderWithTooltipComponent,
    OsNameComponent,
    PercentDataComponent,
    PublisherNameComponent,
    RankDataComponent,
    RankGradeComponent,
    RankingsComponent,
    RankingsHeadersSortPipe,
    RankingsLabelParser,
    RankingsMainFilterItemsComponent,
    RankingsSellerTableComponent,
    RankingsSidenavLinksComponent,
    RatingBarComponent,
    RatingPillComponent,
    RatingSignalComponent,
    ScrollbarHintDirective,
    SellerCountryComponent,
    SellerNameComponent,
    SellerRegionComponent,
    ShowIfPipe,
    WidgetContainerComponent,
    YesnoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    routing,
    PipesModule,
    SharedModule,
    DirectivesModule
  ],
  exports: [
    DataOnlyComponent,
    GridHeaderComponent,
    GridHeaderContainerComponent,
    GridHeaderWithTooltipComponent,
    RankDataComponent,
    RankingsSellerTableComponent,
    RatingSignalComponent,
    WidgetContainerComponent
  ],
  providers: [appRoutingProviders]
})
export class RankingsModule {}
